import type { ToolUseItem } from '@heidi/agents/contracts';
import { useAtomValue } from 'jotai';

import { activeSessionIdAtom } from '@/atoms/liveTranscriptionAtom';
import { openArtifactAtom } from '@heidi/agents/data';
import { useQuerySessionById } from '@heidi/session/data';

const formatElapsed = (totalSeconds: number): string => {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export const SessionRecordingInlineBlock = ({ item }: { item: ToolUseItem }) => {
  const input = (item.input ?? {}) as { action?: string; session_id?: string };
  const isStop = input.action === 'stop';

  const openArtifact = useAtomValue(openArtifactAtom);
  const activeSessionId = useAtomValue(activeSessionIdAtom);
  const artifactSessionId =
    openArtifact?.type === 'session' ? openArtifact.sessionId : null;
  const sessionId = input.session_id ?? artifactSessionId ?? activeSessionId ?? '';

  const { data: duration } = useQuerySessionById({
    sessionId,
    select: (data) => (isStop ? (data?.duration ?? null) : null),
  });

  if (!isStop || typeof duration !== 'number' || duration <= 0) return null;

  return (
    <span className="text-xs tabular-nums text-text-tertiary">
      Duration {formatElapsed(duration)}
    </span>
  );
};
